import React from 'react';
import { connect } from 'react-redux';
import styled, { withTheme } from 'styled-components';
import at from 'lodash/at';
import get from 'lodash/get';
import flattenDeep from 'lodash/flattenDeep';
import { getListProps } from '../../redux/selector/listQuestion';
import ListQuestionAction from '../UIElements/Card/ListQuestionAction';
// eslint-disable-next-line import/no-cycle
import GetElementFunc from '../../util/GetElement';
import TextElement from '../UIElements/TextElement';
// eslint-disable-next-line import/no-cycle
import ListQuestionCard from '../UIElements/Card/ListQuestionCard';
import { insertReflexiveQuestions, scrollQuestionIntoView } from '../../utils';
import ScrollToSection from '../../ScrollToSection';
import { getCSSVariables } from '../../cruxComponents/utils';
// eslint-disable-next-line import/no-cycle
import NestedListQuestions from './NestedListQuestions';
import { setOuterListActionButton } from '../../redux/actions/questions';
import { UPDATE_LAST_FOCUSED_ELEMENT_ID } from '../../redux/types';

const ListWrapper = styled.div`
  ${({ hideReflexWrapper }) => !hideReflexWrapper && 'background: rgba(226, 226, 226, 1)'};
  margin-bottom: ${({ listAddBtnTheme }) =>
    listAddBtnTheme && listAddBtnTheme.position === 'absolute' ? '60px' : '30px'};
  ${({ margin }) =>
    `
    margin:${
      margin?.[0]?.['listQuestions-listWrapper'] || margin?.[1]?.['listQuestions-listWrapper']
    };
  `}
  ${({ reflexLevel, hideReflexWrapper }) =>
    (!hideReflexWrapper &&
      reflexLevel < 1 &&
      `
    padding: 20px;
    margin: 0% -5.5% 0% -5.5%;
  `) ||
    (!hideReflexWrapper &&
      reflexLevel >= 1 &&
      `
      padding: 10px;
    margin: 0% -5.5% 0% -5.5%;
  `)}
  @media only screen and (max-width: 767px) {
    margin: 0;
    padding: 8px 0;
    margin-bottom: ${({ listAddBtnTheme }) =>
      listAddBtnTheme && listAddBtnTheme.position === 'absolute' ? '60px' : '30px'};
  }
`;

const ListQuestionWrapper = styled.div`
  position: relative;
  background: rgba(255, 255, 255, 1);
  ${({ reflexLevel, hideReflexWrapper }) =>
    !hideReflexWrapper &&
    reflexLevel < 1 &&
    `
    padding: 35px 800px 15px 80px;
  `}
  border-radius:${({ themeConfiguration }) =>
    themeConfiguration?.borderRadius ? themeConfiguration?.borderRadius : '8px'};
  @media only screen and (max-width: 1025px) {
    ${({ hideReflexWrapper }) => !hideReflexWrapper && 'padding: 15px'};
  }
  @media only screen and (max-width: 767px) {
    padding: 10px 0;
  }
`;

const CloseAction = styled.div`
  position: absolute;
  right: -15px;
  top: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const isRequired = (question) => {
  return get(question, 'validations.required.value', false);
};

/**
 * @description returns an array of [groupquestion, listquestion]
 * @param questionObject
 * @returns {[*, *]|*[]}
 */
const getListQuestionTitles = (questionObject) => {
  try {
    const groupQ = questionObject;
    const listQText = get(questionObject, 'questions[0].question_text', '');
    return [
      {
        ...groupQ,
        question_text: groupQ.question_text || listQText, // this is a temporary fix,
        // the backend is not sending question text for group question in this case.
      },
      // Commenting sending list question
      // listQ
    ];
  } catch (e) {
    /* eslint-disable no-console */
    console.error('List question assumption failed.', e);
    return [];
  }
};

const getNonListQuestions = (questions) => {
  return questions.filter(
    (q) => get(q, 'display_type', '') !== 'list' && !get(q, 'is_hidden', false),
  );
};

const getFocusSelector = (questionObj, lastFocusedElementId, listDisplay) => {
  const listQId = questionObj.question_id;
  const _listActionIds = [
    'list-add-item-btn',
    'list-add-form-btn',
    'list-update-btn',
    'list-close-btn',
    'list-cancel-btn',
    'list-delete-btn',
    'list-edit-btn',
  ];
  const listActionIds = _listActionIds.map((i) => `${i}-${listQId}`);
  const actionIdRegex = new RegExp(`^(${listActionIds.join('|')})`, 'i');

  // const displayListItems = get(getQuestions([questionObj]), 'questions', []);
  let selector;
  let question;
  if (actionIdRegex.test(lastFocusedElementId)) {
    if (lastFocusedElementId === `list-add-item-btn-${listQId}`) {
      selector = 'div[name="list-question-wrapper"] > div > button'; // close
    } else if (
      [
        'list-add-form-btn',
        'list-update-btn',
        'list-close-btn',
        'list-cancel-btn',
        'list-delete-btn',
      ]
        .map((i) => `${i}-${listQId}`)
        .includes(lastFocusedElementId)
    ) {
      if (listDisplay) {
        // selector = `div#list-item-card-wrapper-${listQId} > div:nth-last-child(2) > div > div.Accordion.expanded > div > div > button`; // edit
        selector = `div#list-item-card-wrapper-${listQId} > button`; // add item
      } else {
        // focus 1st question in list questions
        const listQs =
          Array.isArray(questionObj.questions) && questionObj.questions.length > 0
            ? questionObj.questions
            : questionObj.original_questions;
        const qId = get(listQs, '[0].question_id');
        selector = `#${qId}`; // add item
        question = qId;
      }
    }
  }
  return { selector, question };
};

const ListQuestions = ({
  item,
  qL,
  sectionIndex,
  // listDisplay,
  addButtonText,
  // originalQuestions,
  // questionObj,
  changeMode,
  // listId,
  reflexLevel,
  isReview,
  listAddButtonLabel,
  listAddBtnTheme,
  hideReflexWrapper,
  theme,
  lastFocusedElementId,
  isReflexive,
  skipAutoScroll,
  role,
  // below are the props from NestedListQuestion component:
  nestedListProps,
  currentListAnswerIndex,
  isListAddAction,
  isNestedListAddAction,
  editingParentListIndex = null,
  editingSectionListIndex = null,
  editingParentListId = null,
}) => {
  const _addButtonText = get(item, 'add_button_text', addButtonText || 'Add Record');

  // hide close button for the first list item
  const displayCloseAction = get(item, 'has_items', false);

  let reflexiveListQ = [];
  let listDisplay = get(item, 'child_questions_completed_flag', false);

  const listParentId = get(item, 'question_id', '');
  let isNestedQ = false;
  let parentListIndex = null;
  if (nestedListProps) {
    isNestedQ = get(nestedListProps, 'isNestedQ', true);
    parentListIndex = get(nestedListProps, 'parentListIndex', true);
  }

  if (
    listDisplay &&
    ((!isNestedQ && isListAddAction) ||
      (isNestedListAddAction && isNestedQ && editingParentListIndex === parentListIndex)) &&
    sectionIndex === editingSectionListIndex &&
    editingParentListId === listParentId
  ) {
    listDisplay = false;
  }

  let originalQuestions = get(item, 'original_questions', []);
  if (listDisplay || (!listDisplay && Number.isInteger(item?.current_list_answer_index))) {
    originalQuestions = get(item, 'questions', []);
    listDisplay = true;
  }

  const {
    config: {
      theme: {
        components: {
          card: { themeConfiguration },
        },
      },
    },
  } = theme;

  // CSS Variables
  const cssVariables = getCSSVariables(theme);
  const margin = at(cssVariables, ['pageOverride.margin', 'global.margin']);

  React.useEffect(() => {
    const { selector, question } = getFocusSelector(item, lastFocusedElementId, listDisplay);
    if (question) {
      const element = document.getElementById(question);
      if (element) element.focus();
    } else if (selector) {
      const element = document.querySelector(selector);
      if (element) {
        scrollQuestionIntoView({
          element,
          theme,
          role,
          deviceType: theme.deviceType,
        });
        element.focus();
      }
    }
  }, []);

  if (listDisplay) {
    return (
      <ListQuestionCard
        name='list-question-card'
        sectionIndex={ sectionIndex }
        questionList={ [item] }
        addButtonText={ _addButtonText }
        changeMode={ changeMode }
        listId={ get(item, 'question_id', '') }
        reflexLevel={ reflexLevel }
        isReview={ isReview }
        listParentId={ listParentId }
        // requiredListQIds={requiredListQIds}
        // listQIds={listQIds}
        nestedListProps={ nestedListProps }
        allQuestions={ qL || [] }
        currentListAnswerIndex={ currentListAnswerIndex }
        ql={ qL }
      />
    );
  }

  if (Array.isArray(originalQuestions && originalQuestions[0])) {
    reflexiveListQ = flattenDeep(originalQuestions.map((q) => insertReflexiveQuestions(q)));
  } else {
    reflexiveListQ = insertReflexiveQuestions(originalQuestions);
  }
  if (qL && qL.length) {
    reflexiveListQ.forEach((q) => {
      const match = qL.filter((list) => list.question_id === q.question_id);
      if (match.length) {
        q.response = match[0].response;
      }
    });
  }
  const nonListQuestions = getNonListQuestions(reflexiveListQ);
  const listQIds = nonListQuestions.map((q) => get(q, 'question_id', ''));
  const requiredListQIds = nonListQuestions
    .filter((q) => !['label'].includes(q.question_type) && isRequired(q))
    .map((q) => get(q, 'question_id', ''));

  return (
    <>
      {getListQuestionTitles(item).map((q) => {
        return (
          <>
            <TextElement
              key={ get(q, 'question_id', '') }
              styleType='questions_group' // backend should send this evetually
              text={ get(q, 'question_text', '') }
              questionId={ get(q, 'question_id', '') }
              sectionIndex={ sectionIndex }
              questionObj={ q }
            />
            <TextElement
              key={ get(q, 'question_description', '') }
              text={ get(q, 'question_description', '') }
              sectionIndex={ sectionIndex }
              styleType='list'
              questionObj={ q }
            />
          </>
        );
      })}
      <ScrollToSection
        skipAutoScroll={ isReflexive || skipAutoScroll }
        sectionIndex={ sectionIndex }
        listDisplay={ listDisplay }
      />
      <ListWrapper
        margin={ margin }
        name='list-wrapper'
        reflexLevel={ reflexLevel }
        hideReflexWrapper={ hideReflexWrapper }
        listAddBtnTheme={ listAddBtnTheme }
        id={ get(item, 'question_id') }
      >
        <ListQuestionWrapper
          name='list-question-wrapper'
          reflexLevel={ reflexLevel }
          themeConfiguration={ themeConfiguration }
          hideReflexWrapper={ hideReflexWrapper }
        >
          {!listDisplay && displayCloseAction && (
            <CloseAction name='close-action'>
              <ListQuestionAction
                closeButton
                sectionIndex={ sectionIndex }
                listFormQuestions={ reflexiveListQ }
                listId={ get(item, 'question_id', '') }
              />
            </CloseAction>
          )}
          {reflexiveListQ.map((q) => {
            if (q.display_type === 'list') {
              listDisplay = get(q, 'child_questions_completed_flag', false);
              return (
                <NestedListQuestions
                  name='nested-list-questions'
                  item={ q }
                  sectionIndex={ sectionIndex }
                  changeMode={ changeMode }
                  isReview={ isReview }
                  isNestedQ
                  showListActions={ !isListAddAction && listDisplay }
                  theme={ theme }
                  reflexLevel={ reflexLevel + 1 }
                />
              );
            }
            if (q.is_hidden) return null;

            return (
              <div style={ { maxWidth: '100%' } }>
                <GetElementFunc
                  questionObj={ q }
                  sectionIndex={ sectionIndex }
                  required={ isRequired(q) }
                  isEditMode={ false }
                  listParentId={ listParentId }
                  listIndex={ null }
                  isNestedQ={ isNestedQ }
                  parentListIndex={ parentListIndex }
                />
              </div>
            );
          })}
          <ListQuestionAction
            sectionIndex={ sectionIndex }
            listQIds={ listQIds }
            requiredListQIds={ requiredListQIds }
            listId={ get(item, 'question_id', '') }
            listAddButtonLabel={ listAddButtonLabel }
            listAddBtnTheme={ listAddBtnTheme }
            isNestedQ={ isNestedQ }
            parentListIndex={ parentListIndex }
          />
        </ListQuestionWrapper>
      </ListWrapper>
    </>
  );
};

const mapStateToProps = (state, props) => {
  const { questions } = state;
  const { isLoading } = questions;
  const isListAddAction = get(questions, 'isListAddAction', false);
  const isNestedListAddAction = get(questions, 'isNestedListAddAction', false);
  const editingParentListIndex = get(questions, 'editingParentListIndex', null);
  const editingSectionListIndex = get(questions, 'editingSectionListIndex', null);
  const editingParentListId = get(questions, 'editingParentListId', null);
  const lastFocusedElementId = get(questions, 'lastFocusedElementId', '');
  const isReflexive = get(questions, 'isReflexive', false);
  const role = get(questions, 'role', '');

  const listSelector = getListProps(state);
  const { addButtonText } = listSelector(props.sectionIndex);
  return {
    addButtonText,
    isListAddAction,
    isLoading,
    isNestedListAddAction,
    editingParentListIndex,
    editingSectionListIndex,
    editingParentListId,
    lastFocusedElementId,
    isReflexive,
    role,
  };
};

const mapDispatchToProps = (dispatch) => ({
  setOuterListActionButton: (shouldEnable, sectionIndex) =>
    dispatch(setOuterListActionButton(shouldEnable, sectionIndex)),
  dispatchQuestionFocus: (id) => {
    dispatch({
      type: UPDATE_LAST_FOCUSED_ELEMENT_ID,
      payload: { id },
    });
  },
});

export default withTheme(connect(mapStateToProps, mapDispatchToProps)(ListQuestions));
